// src/common/adminLevelStorage.js
// 目的：把 admin_level 以“伪装键名 + 混淆值（XOR + Base64）”保存到 sessionStorage。
// 说明：只是“降低可见性、提高篡改门槛”，不是安全方案；后端仍需做权限校验。

const APP_TAG = 'snail-admin';              // 改成你的项目标识（影响 key 生成）
const SECRET  = 'v3P:K6}t#1!k@9zL$Q%m^A';   // 随机字符串即可，别泄露到公开仓库

// 生成一个“看起来正常”的键名（带短哈希后缀，降低冲突）
// 示例：__sc_ctx-8f2a1e   或  workbox-precache-9c13ad
function makeDisguisedKey() {
  const cands = ['__sc_ctx', 'workbox-precache', '__cf_bm', '_ga', 'sw:db', '__utmz'];
  const base = cands[hash32(location.host + navigator.userAgent) % cands.length];
  const tail = shortHex(hash32(APP_TAG + location.pathname));
  return `${base}-${tail}`;
}

// djb2 简易 32 位 hash
function hash32(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h) + str.charCodeAt(i);
  return h >>> 0;
}
function shortHex(n) { return (n >>> 0).toString(16).slice(0, 6); }

// xorshift32 生成简单伪随机序列（做异或用）
function* xorshift32(seed) {
  let x = seed >>> 0;
  while (true) {
    x ^= x << 13; x >>>= 0;
    x ^= x >>> 17; x >>>= 0;
    x ^= x << 5;  x >>>= 0;
    yield x & 0xff;
  }
}

// 对字符串做 XOR -> Base64 混淆
function obfuscate(str, salt) {
  const enc = new TextEncoder().encode(str);
  const prng = xorshift32(hash32(SECRET + salt));
  for (let i = 0; i < enc.length; i++) {
    enc[i] = enc[i] ^ prng.next().value;
  }
  // Uint8Array -> base64（用 binary string 转换）
  let bin = '';
  for (let i = 0; i < enc.length; i++) bin += String.fromCharCode(enc[i]);
  return btoa(bin);
}
// 反混淆
function deobfuscate(b64, salt) {
  try {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    const prng = xorshift32(hash32(SECRET + salt));
    for (let i = 0; i < arr.length; i++) arr[i] = arr[i] ^ prng.next().value;
    return new TextDecoder().decode(arr);
  } catch {
    return null;
  }
}

// 对外 API
const AdminLevelStorage = {
  // 保存（混淆）：仅 sessionStorage
  save(level) {
    const key = makeDisguisedKey();
    // 附带时间与随机数，增加“看起来不像等级数字”的假象
    const payload = JSON.stringify({ v: Number(level) || 0, t: Date.now(), r: Math.random() });
    const value = obfuscate(payload, key); // 以“键名”做 salt
    sessionStorage.setItem(key, value);
    return key; // 返回实际使用的键名，便于调试/排查
  },

  // 读取（还原）：自动找出“我们生成的键名”
  load() {
    // 只按当前规则推导的键名取一次，避免遍历所有 storage 键（更“隐蔽”）
    const key = makeDisguisedKey();
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const json = deobfuscate(raw, key);
    if (!json) return null;
    try {
      const obj = JSON.parse(json);
      return (obj && typeof obj.v === 'number') ? obj.v : null;
    } catch {
      return null;
    }
  },

  // 清除
  clear() {
    const key = makeDisguisedKey();
    sessionStorage.removeItem(key);
  }
};

export default AdminLevelStorage;
